import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Partners from './pages/Partners';
import Matrix from './pages/Matrix';

// Solution pages
import DigitalTransformation from './pages/solutions/DigitalTransformation';
import WebDevelopment from './pages/solutions/WebDevelopment';
import MobileApps from './pages/solutions/MobileApps';
import DesktopApps from './pages/solutions/DesktopApps';


// Industry pages
import Healthcare from './pages/industries/Healthcare';
import Finance from './pages/industries/Finance';
import Retail from './pages/industries/Retail';
import Manufacturing from './pages/industries/Manufacturing';
import Education from './pages/industries/Education';
import RealEstate from './pages/industries/RealEstate';
import Logistics from './pages/industries/Logistics';
import Media from './pages/industries/Media';

// Legal pages
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import CookiePolicy from './pages/legal/CookiePolicy';

import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/matrix" element={<Matrix />} />
          <Route path="/partners" element={<Partners />} />
          
          {/* Solution Routes */}
          <Route path="/solutions/digital-transformation" element={<DigitalTransformation />} />
          <Route path="/solutions/web-development" element={<WebDevelopment />} />
          <Route path="/solutions/mobile-apps" element={<MobileApps />} />
          <Route path="/solutions/desktop-apps" element={<DesktopApps />} />

          {/* Industry Routes */}
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/finance" element={<Finance />} />
          <Route path="/industries/retail" element={<Retail />} />
          <Route path="/industries/manufacturing" element={<Manufacturing />} />
          <Route path="/industries/education" element={<Education />} />
          <Route path="/industries/real-estate" element={<RealEstate />} />
          <Route path="/industries/logistics" element={<Logistics />} />
          <Route path="/industries/media" element={<Media />} />

          {/* Legal Routes */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;
